export default __webpack_public_path__ + "static/media/Helvetica-Neue-Medium.b4dad7d2.ttf";